import styled from "styled-components";
import { Space } from "antd";
import { BackArrow } from '@assets';
import lightTheme from '@styles/theme';
import { AuthBg, AuthLogo } from "@assets/auth";

export const RootContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background-image: url(${AuthBg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 0px 16px;

  .ant-form-item-explain {
    text-align: left; /* align warning text to the left */
    margin-left: 24px;
  }

  .ant-btn-primary {
    margin-top: 32px;
    width: 100%;
    height: 56px;
  }
`;
export const NavContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 16px;
`;

export const ArrowIconWrapper = styled.div`
  width: 37px;
  height: 37px;
  background-color: ${lightTheme.appbarColor};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 7px;
  cursor: pointer;
`
export const BackIcon = styled(BackArrow)`
  width: 25px;
  height: 25px;
`;

export const Logo = styled(AuthLogo)`
  margin: 36px 0 0 0;
`

export const ContentContainer = styled.div`
  width: 100%;
  margin: 39px auto 24px;
`
export const Title = styled.div`
  margin: 0 0 55px 0;
  text-align: center;
  color: #FFC654;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const SubTitle = styled.div`
  margin: 0 18px 24px;
  color: var(--white, #FFF);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const StyledInput = styled.input`
  width: 54px !important;
  height: 56px !important;
  border-radius: 8px !important;
  text-align: center !important;
  border:  ${(props) => (props.status === "error" ? "1px solid red" : "1px solid #DDD7CD")} !important;
  font-size: 18px !important;
  padding: 0;
  color: #000;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  -moz-appearance: textfield;
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
  @media screen and (max-width: 380px) {
    width: 45px !important;
    height: 50px !important;
  }
  @media screen and (max-width: 320px) {
    width: 40px !important;
    height: 40px !important;
  }
`;

export const BottomBox = styled(Space)`
  width: 100%;
  margin: 16px 0;

  .ant-space-item:nth-child(1) {
    flex: 1;
  }
`;

export const BottomText = styled.div`
  cursor: pointer;
  color: #DADADA;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const TimeText = styled.div`
  color: #FFF;
  text-align: right;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;


